import { useCorporateConfig } from 'providers/corporate/useCorporateConfig'
import { FORCE_RECARDING_MODULES } from 'lib/feature-flags'

export function useIsRecardingEnabledWithLoading() {
  const { data: corporateConfig, isLoading } = useCorporateConfig()
  return {
    isRecardingEnabled:
      !!corporateConfig?.showRecardingModules || FORCE_RECARDING_MODULES,
    isLoading
  }
}

export function useIsRecardingEnabled() {
  const { isRecardingEnabled } = useIsRecardingEnabledWithLoading()
  return isRecardingEnabled
}
